import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import CloseIcon from '@material-ui/icons/Close';
import {
    Card,
    CardContent,
    Dialog,
    DialogContent,
    DialogTitle,
    DialogActions,
    Typography,
    IconButton,
    Button,
    CircularProgress,
    Accordion,
    AccordionSummary,
    AccordionDetails
} from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import { JsonViewer } from '../../components'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

const useStyles = makeStyles(theme => ({
  labelDiv: {
    display: 'flex',
    margin: '8px 32px'
  },
  innerKeyDiv: {
    width: '150px',
    fontWeight: 500,
    overflowWrap: 'anywhere'
  },
  innerValueDiv: {
    width: '600px',
    overflowWrap: 'anywhere'
  },
  dialogBox: {
    display: 'flex',
    justifyContent: 'space-between',
    margin: '12px'
  },
  closeButton: {
    color: theme.palette.warning.main
  },
  dialogActions: {
    padding: '20px'
  },
  loader: {
    display: 'flex',
    justifyContent: 'center',
    margin: '20%'
  },
  indentation: {
    margin: '8px 48px'
  },
  indentationFont: {
    width: '400px',
    fontWeight: 400,
    overflowWrap: 'anywhere'
  },
  dialogInnerCard: {
    boxShadow: 'none'
  },
  cardContent: {
    display: 'flex',
    flexDirection: 'column',
    rowGap: '8px'
  },
  dialogContent: {
    maxHeight: '70vh',
    overflowY: 'auto'
  },
  accordionRoot: {
    width: '100%'
  }
}));

export default function DisplayArrayModal(props) {
  const classes = useStyles();
  const {
    list,
    title,
    isOpen,
    setIsOpen,
    emptyMessage,
    size,
    isLoading,
    infoMessage
  } = props;
  const safeList = Array.isArray(list) ? list : [];

  const handleClose = () => {
    setIsOpen(false);
  };

  // TODO: Need to seperate this logic as a proper component with variable input
  return (
    <div>
      <Dialog
        fullWidth
        maxWidth={size || 'sm'}
        scroll="paper"
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={isOpen}>
        <div className={classes.dialogBox}>
          <DialogTitle id="customized-dialog-title" onClose={handleClose}>
            <Typography variant="h2">{title}</Typography>
          </DialogTitle>
          <IconButton
            aria-label="close"
            className={classes.closeButton}
            onClick={handleClose}>
            <CloseIcon />
          </IconButton>
        </div>
        {safeList.length > 0 && infoMessage && (
          <Alert severity="info" style={{ marginLeft: '40px', marginRight: '55px' }}>
            {infoMessage}
          </Alert>
        )}
        <DialogContent className={classes.dialogContent}>
          <Card className={emptyMessage.show ? '' : classes.dialogInnerCard}>
            <CardContent className={classes.cardContent}>
              {isLoading ? (
                <div className={classes.loader}>
                  <CircularProgress />
                </div>
              ) : (
                <React.Fragment>
                  {emptyMessage && emptyMessage.show && (
                    <div style={{ padding: '20px' }}>{emptyMessage.msg}</div>
                  )}
                  {safeList.map((listValue, index) => {
                    const headerId = `event-log-${index}-header`;
                    const contentId = `event-log-${index}-content`;
                    // Generate a stable key: use id if available, else hash the item's content
                    const getStableKey = (item, idx) => {
                      if (item?.id) return item.id;
                      // Simple hash function for demonstration (not cryptographically secure)
                      const str = JSON.stringify(item) + idx;
                      let hash = 0, i, chr;
                      for (i = 0; i < str.length; i++) {
                        chr = str.charCodeAt(i);
                        hash = ((hash << 5) - hash) + chr;
                        hash |= 0;
                      }
                      return `item-${hash}`;
                    };
                    return (
                      <Accordion key={getStableKey(listValue, index)} className={classes.accordionRoot}>
                        <AccordionSummary
                          expandIcon={<ExpandMoreIcon />}
                          aria-controls={contentId}
                          id={headerId}
                        >
                          <div>
                            <div className={classes.labelDiv}>
                              <div className={classes.innerKeyDiv}>Event Type :</div>
                              <div>{listValue.eventType}</div>
                            </div>
                            <div className={classes.labelDiv}>
                              <div className={classes.innerKeyDiv}>Occurred At :</div>
                              <div>{listValue.occurredTimeAndDate}</div>
                            </div>
                          </div>
                        </AccordionSummary>
                        <AccordionDetails id={contentId} style={{ paddingTop: '0px' }}>
                          <JsonViewer src={listValue.payload} />
                        </AccordionDetails>
                      </Accordion>
                    );
                  })}
                </React.Fragment>
              )}
            </CardContent>
          </Card>
        </DialogContent>
        <DialogActions className={classes.dialogActions}>
          <Button variant="contained" onClick={handleClose} color="primary">
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
